import React from "react";
import LoginAndRegister from "../Auth/LoginAndRegister";
const LoginPage = () => {
  return <LoginAndRegister loginOrRegister={"login"} />;
};

export default LoginPage;
